import ShowByRole from 'App/components/ShowByRole';
import { TransactionFeesPaymentModal } from 'domains/Billing/TransactionFees/components';
import RateSuggestionModal from '../RateSuggestionModal';
import TransactionFeeToPayInfoModal from '../TransactionFeeToPayInfoModal';

export function DashboardModals() {
  return (
    <>
      <ShowByRole includeRoles="full">
        <TransactionFeeToPayInfoModal />
      </ShowByRole>
      <ShowByRole includeRoles="full">
        <TransactionFeesPaymentModal initialFetch={false} />
      </ShowByRole>
      <ShowByRole includeRoles="full">
        <RateSuggestionModal />
      </ShowByRole>
    </>
  );
}
